import { controls, ll } from "../..";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_MaskedTextBox from "../templates/K_MaskedTextBox";
import { InputOptions } from "./input";
import { TemplateComponent } from "./templateComponent";

export interface MaskedTextBoxOptions extends InputOptions {
    mask: string;
}

export class MaskedTextBox extends TemplateComponent {

    options: MaskedTextBoxOptions;

    constructor(options: MaskedTextBoxOptions) {
        super(K_MaskedTextBox, options);
    }

    preRender() {
        const options = this.options;

        // Set defaults for woop fields
        if (options.labelAbove) {
            options.bsc = options.bsc || " ";
            if (options.valueWidth) {
                options.containerWidth = options.containerWidth || +options.valueWidth + 10;
                options.labelWidth = options.labelWidth || options.valueWidth;
            }
            options.labelAbove = buildDataBindSyntax(options.labelAbove, "text");
        }

        options.label = buildDataBindSyntax(options.label, "text");
        options.title = buildDataBindSyntax(options.label, "text");
        options.required = options.required || false;
        options.bindValue = buildDataBindSyntax(options.bindValue, "input");
        options.placeholder = options.placeholder || "";

        options.containerClasses = options.containerClasses || "";
        options.containerBind = buildDataBindSyntax(options.containerBind, "container");
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.labelBsc = options.labelBsc || "col-xs-5";
        options.inputBsc = options.inputBsc || "col-xs-7  no-pad";
        options.iconType = options.iconType || "";
    }

    create() {
        var me = this;
        var maskedTextBox = $("#" + me.options.id);

        maskedTextBox.kendoMaskedTextBox({
            mask: me.options.mask
        });
    }

}
